import React, { useState } from "react";
import ButtonLoading from "../../Button/ButtonLoading";
import { Box, Stack, TextField, Typography } from "@mui/material";
import ContentBox from "../../ContentBox/ContentBox";
import FetchBeaMessages from "./FetchBeaMessages";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys, updateResource } from "../../../services/ReactQuery/reactQueryService";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import DeleteBeAData from "./DeleteBeAData";
import { Dropzone } from "../../Dropzone/Dropzone";

export default function BeAData() {
  const currentUser = useCurrentUser();
  const [files, setFiles] = useState<File[]>([]);
  const [refreshDropZoneTrigger, setRefreshDropZoneTrigger] = useState(0);
  const [pin, setPin] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const updateMutation = useMutation({
    mutationFn: updateResource
  });
  const queryClient = useQueryClient();

  if (!currentUser.isLawyer) {
    return null;
  }

  const handleSave = async () => {
    setIsLoading(true);
    const encodedFile = await toBase64(files[0]);
    const sanitizedEncodedFile = stripDataInfo(encodedFile);
    await updateMutation.mutateAsync({
      uri: "backoffice_people",
      id: currentUser.person.id,
      data: {
        encodedBeaCertificate: sanitizedEncodedFile,
        plainBeaPin: pin,
      },
    });
    await queryClient.invalidateQueries({
      queryKey: queryKeys.all("backoffice_users")
    });
    await queryClient.invalidateQueries({
      queryKey: queryKeys.all("current_user")
    });
    setPin("");
    setFiles([]);
    setRefreshDropZoneTrigger(refreshDropZoneTrigger + 1);
    setIsLoading(false);
  };

  return (
    <ContentBox headline={"beA"}>
      <Stack
        spacing={3}
        sx={{
          alignItems: "center",
          marginTop: "4rem",
        }}
      >
        <Typography variant={"h3"}>Upload beA-Zertifikat</Typography>
        {currentUser.person.beaData && (
          <Typography sx={{ color: "green" }}>Sie haben aktuell ein Zertifikat und einen PIN hinterlegt</Typography>
        )}
        {/*this key is unfortunately needed to reset the content of the dropzone*/}
        <Box key={refreshDropZoneTrigger} sx={{ width: "100%" }}>
          <Dropzone
            onChange={(files) => setFiles(files)}
            filesLimit={1}
            dropzoneText={"Zertifikat hochladen"}
            maxFileSize={300000000}
            acceptedFiles={[".p12"]}
            fileObjects={files}
          />
        </Box>
        <TextField
          fullWidth={false}
          label={"PIN"}
          type={"password"}
          value={pin}
          onChange={(event) => setPin(event.target.value)}
        />
        <ButtonLoading
          variant={"contained"}
          disabled={files.length !== 1 || pin.length !== 6}
          onClick={handleSave}
          isLoading={isLoading}
          sx={{ width: 200 }}
        >
          Speichern
        </ButtonLoading>
      </Stack>
      <DeleteBeAData />
      <FetchBeaMessages />
    </ContentBox>
  );
}

const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    // @ts-ignore //since readAsDataURL is used it can only be a string
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const stripDataInfo = (encodedFile: string) => {
  const cutOfPointIdentifier = ";base64,";
  return encodedFile.substring(encodedFile.indexOf(cutOfPointIdentifier) + cutOfPointIdentifier.length);
};
